<template>
    <!--<Dropdown
        v-model="selected"
        :items="publisher"
        item-text="Name" item-value="Name"
        label="Publisher"
        :multiple="true"
        @delete="remove"
        @change="updateSelectedPublisher"
    >
    </Dropdown>-->
    <div class="d-flex flex-column">
        <transition name="fade" mode="out-in">
            <div v-if="$store.state.display.loadingPublisher" class="d-flex align-center" :key="0">
                <v-progress-circular :size="20" :color="ada.pink" width="2" indeterminate
                ></v-progress-circular>
                <div class="ml-4">Publisher werden geladen...</div>
            </div>
            <div v-else :key="1">
                <span class="label blue-grey--text text--darken-1">Publisher</span>
                <div class="checkbox_container">
                    <v-checkbox class="mr-6"
                                v-model="selected" v-for="(item, i) in publisher" :key="'publisher_checkbox_'+i"
                                :color="ada.blue"
                                :value="item"
                                @change="updateSelectedPublisher(item)"
                    >
                        <template #label>
                            <div :style="{color: ada.darkGrey}">{{ item.Name }}</div>
                        </template>
                    </v-checkbox>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import ada from "../../scss/ada_colors.scss";

export default {
    name: "PublisherSelect",
    props: {
        store: {
            type: String,
            default: 'display',
        },
        commit: {
            type: String,
            default: 'updateSelectedPublisher',
        }
    },
    components: {},
    data: () => {
        return {
            selected: [],
            lastSelected: null,
            initial: true,
            ada
        }
    },
    mounted() {
        if (this.publisher.length === 0) {
            this.$store.dispatch('display/fetchPublisher');
        }
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        publisher() {
            return this.vuexState.publisher || [];
        },
        selectedPublisher() {
            return this.vuexState.selectedPublisher;
        }
    },
    methods: {
        init() {
            this.selected = this.$store.state[this.store].selectedPublisher;
        },
        updateSelectedPublisher(value) {
            if (this.lastSelected && value.PublisherId === this.lastSelected.PublisherId && this.selected.length === 0) {
                this.selected = [];
            } else {
                this.lastSelected = value;
                this.selected = [value];
            }
            this.$store.commit(this.store + '/' + this.commit, {data: this.selected});
        }
    },
    watch: {
        selectedPublisher() {
            if (this.initial) {
                this.init();
                this.initial = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .checkbox_container {
    display: flex;
    flex-flow: wrap;
    flex-flow: wrap;
    width: 100%;
    justify-content: flex-start;

    .v-input {
        margin-top: 0;
    }
}

.label {
    font-size: 12px;
    height: 5px;
}

</style>